import { Button, ButtonProps, CircularProgress } from "@mui/material";

interface LoadingButtonProps extends ButtonProps {
  loading: boolean;
  loadingColor?: string;
  title: string;
  width?: number;

}

function LoadingButton(props: LoadingButtonProps) {
  const {
    loading,
    loadingColor = "white",
    title,
    variant = "contained",
    size = "medium",
    color = "primary",
    width = 30,
    ...btnProps
  } = props;
  return (
    <Button {...btnProps} color={color} size={size} variant={variant} disabled={loading || btnProps.disabled}>
      {loading ? (
        <CircularProgress size={width} sx={{ color: loadingColor }} />
      ) : (
        title
      )}
    </Button>
  );
}

export default LoadingButton;
